/** 
 * 触发 Dialog 的按钮的事件
 */
// (function () {
$(document).ready(function(){
  const dialogBtnEls = document.querySelectorAll(".moft-show-dialog[data-moft-show-dialog]");
  if (dialogBtnEls.length <= 0) return;
  const overlayEl = document.querySelector(".mask-overlay");
  const htmlEl = document.querySelector("html");
  overlayEl.addEventListener("click", function (e) {
    const dialogEl = document.querySelector(".moft-dialog--opened");
    if(dialogEl) {
      dialogEl.classList.remove("moft-dialog--opened");
      setTimeout(() => {
        dialogEl.style.display = "none";
      }, 301);
    }
    overlayEl.classList.remove("mask_opened");
    htmlEl.classList.remove("hside_opened");
  });
  for (let i = 0; i < dialogBtnEls.length; i++) {
    const dialogBtnEl = dialogBtnEls[i];
    dialogBtnEl.addEventListener("click", function (e) {
      const current = dialogBtnEl;
      const id = current.getAttribute("data-dialog-id");
      const dialogEl = document.getElementById(`moft-dialog__${id}`);
      dialogEl.style.display = "block";
      dialogEl.classList.add("moft-dialog--opened");
      htmlEl.classList.add("hside_opened");
      overlayEl.classList.add("mask_opened");
      $(window).trigger('resize');
      geckoShopify.init();
    })
  }

  window.addEventListener("load", function() {
    const dialogEls = document.querySelectorAll(".moft-dialog");
    if (dialogEls.length <= 0) return;
    // Dialog 初始化产品组件
    let nt_pr_js_list = document.querySelectorAll("[data-js-callback] .nt_pr_js");
    for (let el of nt_pr_js_list) {
      var pr_id = $(el).attr('data-id');
      // console.log('pr_id: ', pr_id);
      geckoShopify.NtproductPage(pr_id);
    }
  });
// })();
});


/** 
 * Dialog 关闭按钮的事件
 */
$(document).ready(function(){
  const dialogEls = document.querySelectorAll(".moft-dialog");
  if (dialogEls.length <= 0) return;
  const overlayEl = document.querySelector(".mask-overlay");
  const htmlEl = document.querySelector("html");
  for (let i = 0; i < dialogEls.length; i++) {
    const dialogEl = dialogEls[i];
    const closeBtnEl = dialogEl.querySelector(".moft-dialog__close");
    closeBtnEl.addEventListener("click", function () {
      dialogEl.classList.remove("moft-dialog--opened");
      setTimeout(() => {
        dialogEl.style.display = "none";
      }, 301);
      overlayEl.classList.remove("mask_opened");
      htmlEl.classList.remove("hside_opened");
    });
  }
});


/**
 * 解决 Dialog 与 侧边 Cart 冲突
 */
$(document).ready(function(){
  const dialogEl = document.querySelector(".moft-dialog");
  if (!dialogEl) return;
  // 目标元素
  const target = document.querySelector('body');
  // 创建一个MutationObserver实例
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // 监听到 class 属性发生变化，执行相应的操作
        if (target.classList.contains("pside_opened")) {
          const dialogEls = document.querySelectorAll(".moft-dialog");
          for (let el of dialogEls) {
            el.classList.remove("moft-dialog--opened");
            setTimeout(() => {
              el.style.display = "none";
            }, 301);
          } // 关闭 Dialog
        }
      }
    });
  });
  // 配置观察选项
  const config = { attributes: true };
  // 传入目标节点和观察选项开始观察
  observer.observe(target, config);
});